import Flickity from "flickity";
// import Flickity from "flickity-fade";

function Slider(el) {
  el.classList.remove("hidden");
  const options = el.dataset?.options ? JSON.parse(el.dataset.options) : {};
  const indexEl = el.parentElement.querySelector("[data-index]");

  const flk = new Flickity(el, options);

  function prevSlide() {
    flk.previous();
    console.log("Prev slide");
  }

  function nextSlide() {
    flk.next();
    console.log("testslider");
  }

  const prev = document.querySelector(options.prevButton2);
  if (prev) {
    prev.addEventListener("click", prevSlide);
  }
  const next = document.querySelector(options.nextButton2);
  if (next) {
    next.addEventListener("click", nextSlide);
  }

  flk.on("change", (index) => {
    if (indexEl) indexEl.innerText = index + 1;
  });
}

export default Slider;
